<template>
  <layout-main-inner
    v-loading="loading"
    title="鉴定单查询">
    <!-- <div slot="action">
      <el-button
        type="primary"
        style="margin-right: 10px"
        @click="viewDustbin">前往垃圾箱</el-button>
    </div> -->
    <layout-card-wrap>
      <el-form
        label-width="85px"
        @submit.native.prevent>
        <el-row
          :gutter="4"
          type="flex">
          <el-col :span="6">
            <el-form-item label="委托时间:">
              <el-date-picker
                v-model="config.time"
                placement="bottom-start"
                style="width: 100%;"
                type="datetimerange"
                range-separator="/"
                :editable="false"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="开始"
                end-placeholder="结束"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="关键词:">
              <el-tooltip
                effect="dark"
                content="该表单支持发货物流单号，鉴定单号、溯源码、回寄物流单号、商家单号，精确+模糊查询"
                placement="top-start">
                <el-input
                  v-model.trim="config.keyword"
                  style="width: 100%"
                  clearable
                  placeholder="请输入查询关键词"></el-input>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="来源商家:">
              <ent-remote-select
                v-model="config.vendorId"
                style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label=""
              label-width="0">
              <el-button
                type="primary"
                @click="handleCurrentChange(1)">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :row-class-name="rowClass"
        :data="list">
        <el-table-column
          label="鉴定单号"
          min-width="200"
          fixed="left"
          prop="appraisalNo">
          <template slot-scope="{ row }">
            <div>
              <el-tag
                type="info"
                effect="dark"
                size="mini">委托</el-tag>
              <span style="margin-left: 4px"> {{ row.appraisalNo }}</span>
            </div>
            <div v-if="row.orderSource !== 1">
              <el-tag
                type="warning"
                effect="dark"
                size="mini">{{ row.orderSource | orderSourceName() }}</el-tag>
              <span style="margin-left: 4px"> {{ row.yhbBizOrderId }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="商品"
          min-width="200"
          prop="spuName"></el-table-column>
        <el-table-column
          label="委托类型"
          min-width="90"
          prop="appraisalType">
          <template slot-scope="{ row }">{{ row.appraisalType | appraisalTypeName() }}</template>
        </el-table-column>
        <el-table-column
          label="证书编号"
          min-width="150"
          prop="certNo"></el-table-column>
        <el-table-column
          label="商品识别码"
          min-width="120"
          prop="tagNo"></el-table-column>
        <el-table-column
          label="费用"
          min-width="70"
          :formatter="row=> '￥' + row.appraisalFee"
          prop="appraisalFee"></el-table-column>
        <el-table-column
          label="当前状态"
          min-width="90">
          <template slot-scope="{ row }">{{ row.status | orderStatusName() }}</template>
        </el-table-column>
        <el-table-column
          label="结算状态"
          min-width="90">
          <template slot-scope="{ row }">{{ row.settlementStatus | SettlementStatusName() }}</template>
        </el-table-column>
        <el-table-column
          label="鉴定结果"
          width="90">
          <template slot-scope="{ row }">
            <span>{{ row.appraisalResult | appraisalResultName() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="推送结果"
          width="70">
          <template slot-scope="{ row }">
            <template v-if="![1, 3].includes(row.orderSource)&& row.status > 8">
              <fail-orders-message-popover
                v-if="row.yhbAppraisalResultSynced === 0 && row.yhbAppraisalResultSyncFailInfo"
                :row="row">
                <span>同步失败</span>
              </fail-orders-message-popover>
              <span v-else>{{ row.yhbAppraisalResultSynced === 0 ? '未同步' : '已同步' }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          label="物流单号"
          min-width="200">
          <template slot-scope="{ row }">
            <div v-if="row.senderCourierNumber">
              <el-tag
                size="mini"
                effect="dark">发货</el-tag>
              <span style="margin-left: 4px">{{ row.senderCourierNumber }}</span>
            </div>
            <div v-if="row.appraisalDeliveryCourierNumber">
              <el-tag
                size="mini"
                effect="dark">回寄</el-tag>
              <span style="margin-left: 4px">{{ row.appraisalDeliveryCourierNumber }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="商家名称"
          min-width="140"
          prop="vendorName"></el-table-column>
        <el-table-column
          label="鉴定中心"
          min-width="80"
          prop="roomName"></el-table-column>
        <el-table-column
          label="委托时间"
          width="140">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="完成时间"
          width="140">
          <template slot-scope="{ row }">{{ row.appraisalReviewTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="同步状态"
          min-width="80"
          prop="canSyncCcicGroup20">
          <template slot-scope="{ row }">{{ row.canSyncCcicGroup20 | syncStatusName() }}</template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="80">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="viewDetail(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        :page-sizes="[10, 20, 30]"
        layout="total,sizes, prev, pager, next"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
    <appraisal-detail-drawer ref="detail" />
  </layout-main-inner>
</template>
<script>
import AppraisalDetailDrawer from './appraisal-detail-drawer.vue'
import moment from 'moment'
import FailOrdersMessagePopover from './fail-orders-message-popover.vue'
import EntRemoteSelect from '../ent-remote-select.vue'
import Appraise from '@/service/appraise'
export default {
  name: 'BalanceIndex',
  components: { EntRemoteSelect, FailOrdersMessagePopover, AppraisalDetailDrawer },
  data() {
    const time = [+moment().subtract(1, 'months').startOf('days'), +moment().endOf('days')]
    return {
      loading: false,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, keyword: '', vendorId: null, time }
    }
  },
  methods: {
    // viewDustbin() {
    //   this.$router.push({ path: '/appraisal-order-dustbin' })
    // },
    rowClass({ row }) {
      const { appraisalResult } = row
      const mapObj = { 1: 'row-success', 2: 'row-success', 3: 'row-error', 10: 'row-warning' }
      return mapObj[appraisalResult] || ''
    },
    gettime() {
      const { time } = this.config
      const [beginTime, endTime] = time || [null, null]
      return { beginTime: +beginTime || null, endTime: +endTime || null, time: undefined }
    },
    viewDetail(row) {
      this.$refs.detail.fetch({ id: row.id })
    },
    handleSizeChange(val) {
      this.config.pageSize = val
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      const { keyword, vendorId, time } = this.config
      if (!keyword && !vendorId) {
        this.$message.error('关键词为空时必须选择一个商家')
        return
      }
      if (!keyword && !time) {
        this.$message.error('关键词为空时必须选择一个时间段')
        return
      }
      this.loading = true
      Appraise.getappraisalorders2({ ...this.config, ...this.gettime() })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if (result === 0) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
<style lang="stylus">
.row-error,.row-error.hover-row>td{
  background-color: #ff9e9e !important
}

.row-warning,.row-warning.hover-row>td{
  background-color: oldlace !important
}
.row-success,.row-success.hover-row>td{
  background-color: #e1f3d8 !important
}
</style>
